import React, { useMemo, useRef } from 'react';

import { Col, Row } from '@opendoor/atoms/box';
import { NavMenuProvider } from 'components/landing-pages-v2/shared/NavMenuContext';
import { COSMOS_ASSET_ORIGIN } from 'components/shared/performance/preloads';
import StaticSiteFooter from 'components/static-site/StaticSiteFooter';
import StaticSiteHeader from 'components/static-site/StaticSiteHeader';
import Head from 'next/head';

const setHeight = `
  html,
  body,
  div#__next {
    height: 100%;
  }
`;

interface MarketplaceMapLayoutProps {
  children: React.ReactNode;
}

const MarketplaceMapLayout = ({ children }: MarketplaceMapLayoutProps) => {
  const closeMenuRef = useRef(() => {});
  const navMenuValue = useMemo(() => ({ closeMenu: () => closeMenuRef.current() }), []);

  return (
    <>
      <Head>
        <link rel="preconnect" href="https://images.opendoor.com" />
        <link rel="dns-prefetch" href="https://images.opendoor.com" />
        {COSMOS_ASSET_ORIGIN && (
          <link rel="preconnect" href={COSMOS_ASSET_ORIGIN} crossOrigin="anonymous" />
        )}
        {COSMOS_ASSET_ORIGIN && <link rel="dns-prefetch" href={COSMOS_ASSET_ORIGIN} />}
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <meta httpEquiv="Accept-CH" content="DPR, Width, Viewport-Width" />
        <link
          rel="apple-touch-icon"
          sizes="144x144"
          href="https://www.opendoor.com/apple-touch-icon-144.png"
        />
        <style>{setHeight}</style>
      </Head>
      <NavMenuProvider value={navMenuValue}>
        <Col className="min-h-dvh">
          {/* always 72px tall */}
          <StaticSiteHeader slug="homes" closeMenuRef={closeMenuRef} />
          <Row
            as="main"
            tabIndex={-1}
            className="h-[calc(100dvh-var(--spacing)*18)] shrink-0 overflow-hidden bg-od-bg-primary"
          >
            {children}
          </Row>
          <StaticSiteFooter />
        </Col>
      </NavMenuProvider>
    </>
  );
};

export default MarketplaceMapLayout;
